import ThankYouScreen from "./ThankYouScreen";
export default ThankYouScreen;
